import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "fieldset"]

  connect() {
    const selected = this.selectTarget.value

    this.fieldsetTargets.forEach((fieldset) => {
      if (fieldset.dataset.value != selected) {
        fieldset.setAttribute("disabled", true)
        fieldset.setAttribute("hidden", true)
      }
    })
  }

  change() {
    const selected = this.selectTarget.value

    this.fieldsetTargets.forEach((fieldset) => {
      if (fieldset.dataset.value == selected) {
        fieldset.removeAttribute("disabled")
        fieldset.removeAttribute("hidden")
      } else {
        fieldset.setAttribute("disabled", true)
        fieldset.setAttribute("hidden", true)
      }
    })
  }
}